import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { adminLogin } from "../../Features/Auth/authThunk";
import { primeNotificationAudioFromUserGesture } from "../../utils/playNotificationSound";

import "react-phone-input-2/lib/style.css";
import "./AdminLogin.scss";

import passf from "../../Assets/passF.png";
import pass from "../../Assets/pass.png";
import eyeClose from "../../Assets/eyebtnopn.png";
import eyeOpen from "../../Assets/eyebtnC.png";
import circle from "../../Assets/circle.png";
import undercir from "../../Assets/undercir.png";
import bwava from "../../Assets/Bigwave.png";

export default function AdminLogin() {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.auth);

  const [showPass, setShowPass] = useState(false);
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");

  const onMobileChange = (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 10);
    setMobile(digitsOnly);
  };

  const onPasswordChange = (e) => {
    setPassword(e.target.value);
  };

  /* ✅ LOGIN */
  const handleLogin = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (loading) return;
    if (mobile.length !== 10 || !password) return;

    primeNotificationAudioFromUserGesture();

    const result = await dispatch(
      adminLogin({
        mobile,
        password,
      })
    );

    if (adminLogin.fulfilled.match(result)) {
      navigate("/Dashboard");
    }
  };

  return (
    <div className="admin-login-page">

      <div className="shape_o"><img src={circle} alt="" /></div>
      <div className="shape_t"><img src={undercir} alt="" /></div>
      <div className="shape_th"><img src={bwava} alt="" /></div>

      <div className="container">
        <div className="login-wrapper">

          <h1>Admin Login</h1>
          <p className="sub">
            Authorized access for platform administrators only.
          </p>

          <form className="login-card" onSubmit={handleLogin} noValidate>

            {/* MOBILE */}
            <div className="input-box">
              <span className="icon">
                <img src={passf} alt="" />
              </span>

              <input
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="10-digit mobile"
                value={mobile}
                onChange={onMobileChange}
                autoComplete="username"
                maxLength={10}
                minLength={10}
                required
                aria-label="Mobile number"
              />
            </div>

            {/* PASSWORD */}
            <div className="input-box">
              <span className="icon">
                <img src={pass} alt="" />
              </span>

              <input
                type={showPass ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={onPasswordChange}
                autoComplete="current-password"
                required
                minLength={8}
                maxLength={128}
                aria-label="Password"
              />

              <button
                type="button"
                className="eye"
                onClick={() => setShowPass(!showPass)}
                aria-label={showPass ? "Hide password" : "Show password"}
              >
                <img src={showPass ? eyeClose : eyeOpen} alt="" />
              </button>
            </div>

            {/* LOGIN BUTTON */}
            <button
              type="submit"
              className="login-btn"
              disabled={loading || mobile.length !== 10 || password.length < 8}
            >
              {loading ? "Logging..." : "Login"}
            </button>

            {error && <p className="error">{error}</p>}

            <div className="brand-credit">
              <span>Developed by </span>
              <a href="https://prilixlabs.com" target="_blank" rel="noreferrer">
                Prilix Labs
              </a>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
}